import request from '@/utils/request'

const prefix = '/django_rest/audit-logs/'

export default {
  getAuditLogList (params) {
    return request.get(`${prefix}`, { params })
  }
}
